import { MediaFileService } from '../../data/media-file.service.ts'
import { mapFolderContentDtoToFolderContent } from '../mappers/map-foldersdto-to-folders.ts'
import type { FolderContent } from '../models/media-folder.ts'

export const getFolderContent = async (id?: string): Promise<FolderContent> => {
  const folderContentDto = await MediaFileService.getFolderContent(id)
  return mapFolderContentDtoToFolderContent(folderContentDto)
}
